import Main from "./pages/Main.jsx";

function App() {
  return (
    <Main/>
  );
}

export default App;
